import { render, staticRenderFns } from "./CommercantBanner.vue?vue&type=template&id=c73dc376&scoped=true&"
import script from "./CommercantBanner.vue?vue&type=script&lang=js&"
export * from "./CommercantBanner.vue?vue&type=script&lang=js&"
import style0 from "./CommercantBanner.vue?vue&type=style&index=0&id=c73dc376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73dc376",
  null
  
)

export default component.exports